import { NgModule, Injector } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
// import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { SplitPanes } from './split.panes';
import { ConfirmDialog } from './confirm.dialog';
import { ImportMaterialModule } from '../material.module';
import { UIService } from '../ui.service';
import { AvatarDirective } from './avatar.directive';
import { InputAcceptDirective } from './input.accept.directive';
import { ToastrModule } from 'ngx-toastr';
import { AvatarProvider } from './avatar.provider';
import { LongFileNamePipe } from './longfilename.pipe';
import { FileDropDirective } from './filedrop.directive';

import { AngularResizedEventModule } from 'angular-resize-event';
import { ExportProvider } from '../table/export';
import { PrimeTable } from '../table/prime.table';
import { ImportPrimeModule } from '../prime.module';
import { TimeagoModule } from 'ngx-timeago';
import { DatePipe } from '@angular/common';
import { TimeLabel } from './time.label';
import { ResLink } from '../link/res.link';
import { StyledSpan } from './styled.span';

@NgModule({
    declarations: [
        // SplitPanes, 
        ConfirmDialog,
        PrimeTable,
        AvatarDirective, InputAcceptDirective, FileDropDirective,
        LongFileNamePipe,
        TimeLabel,

        ResLink,
        StyledSpan,
    //    UIService
    ],
    imports: [
        CommonModule,
        ImportMaterialModule,
        ImportPrimeModule,
        AngularResizedEventModule,
        TimeagoModule.forChild(),
        
        //ToastrModule.forChild()
        // BrowserModule,
        // BrowserAnimationsModule
    ],
    exports: [
        // ImportMaterialModule,
        // ImportPrimeModule,
        AngularResizedEventModule,
        TimeagoModule,

        // SplitPanes, 
        ConfirmDialog,
        PrimeTable,
        AvatarDirective, InputAcceptDirective, FileDropDirective,
        LongFileNamePipe,
        TimeLabel,

        ResLink,
        StyledSpan,
    ],
    providers: [
        UIService, AvatarProvider,
        ExportProvider,
        DatePipe, DecimalPipe,
    ],
    entryComponents: [
        ConfirmDialog
    ]
})
export class ToolsModule {
}